{
  "dropzoneLabel": "Ablegebereich",
  "selectPlaceholder": "Element wählen",
  "tableResizer": "Größenanpassung",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
